import { updateSourceAccess } from "api/Sources";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useUpdateSourceAccess = () => {
    const queryClient = useQueryClient();
    
    return useMutation(updateSourceAccess, {
        onSuccess: () => {
            toast.success("Source access updated successfully!");
            queryClient.invalidateQueries('sources')
        },
        onError: (err:any) => {
            if(err?.response?.data?.error === 'Unauthenticated'){
                toast.error('Unauthenticated')
            }else if(err?.response?.data?.message){
                toast.warning(err?.response?.data?.message)
            } else {
                toast.error("An unknown error occurred");
            }
        }
    })
}